(function () {
  function initSection(section) {
    if (section.dataset.initialized === 'true') return;
    section.dataset.initialized = 'true';

    const grid = section.querySelector('[data-hs-cat-grid]');
    const prev = section.querySelector('[data-hs-cat-prev]');
    const next = section.querySelector('[data-hs-cat-next]');
    if (!grid || !prev || !next) return;

    const cardWidth = () => {
      const first = grid.firstElementChild;
      if (!first) return 0;
      const styles = getComputedStyle(grid);
      const gap = parseFloat(styles.columnGap || styles.gap || '0');
      return first.getBoundingClientRect().width + gap;
    };

    const updateButtons = () => {
      const maxScroll = grid.scrollWidth - grid.clientWidth - 1;
      prev.toggleAttribute('disabled', grid.scrollLeft <= 0);
      next.toggleAttribute('disabled', grid.scrollLeft >= maxScroll);
      const noOverflow = grid.scrollWidth <= grid.clientWidth + 2;
      section.querySelector('.hs-cat__nav').style.display = noOverflow ? 'none' : '';
    };

    prev.addEventListener('click', () => {
      grid.scrollBy({ left: -cardWidth() * 2, behavior: 'smooth' });
    });
    next.addEventListener('click', () => {
      grid.scrollBy({ left: cardWidth() * 2, behavior: 'smooth' });
    });

    grid.addEventListener('scroll', updateButtons, { passive: true });
    window.addEventListener('resize', updateButtons);
    section._hsCatCleanup = () => window.removeEventListener('resize', updateButtons);
    updateButtons();
  }

  function init() {
    document.querySelectorAll('[data-hs-cat]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', (e) => {
      const sec = e.target.querySelector('[data-hs-cat]') || e.target.closest('[data-hs-cat]');
      if (sec) initSection(sec);
    });
    document.addEventListener('shopify:section:unload', (e) => {
      const sec = e.target.querySelector('[data-hs-cat]') || e.target.closest('[data-hs-cat]');
      if (sec && typeof sec._hsCatCleanup === 'function') sec._hsCatCleanup();
    });
  }
})();
